import { Component, computed, effect, inject, signal } from "@angular/core";
import { DatePipe } from "@angular/common";
import { CardModalService } from "@shared/card-modal";
import { JobsBillingCard } from "@app/views-interfaces";
import { JobsAndBillingJobTypesService } from "@shared/jobs-and-billing-job-types-service/jobs-and-billing-job-types.service";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";

@Component({
    selector: "wk-jobs-billing-north-panel",
    imports: [DatePipe, JumpstartComponentsModule],
    templateUrl: "./jobs-billing-north-panel.component.html",
    styleUrl: "./jobs-billing-north-panel.component.scss",
})
export class JobsBillingNorthPanelComponent {
    public readonly cardModalService = inject(CardModalService);
    private readonly jobsAndBillingJobTypesService = inject(JobsAndBillingJobTypesService);

    readonly jobsBillingCard = computed(() => this.cardModalService.currentCard() as JobsBillingCard);
    readonly jobTypeShortCode = signal<string | null>(null);

    constructor() {
        effect(() => {
            const typeId = this.jobsBillingCard()?.job?.typeId;
            if (typeId != null) {
                this.loadJobTypeShortCode(typeId);
            } else {
                this.jobTypeShortCode.set(null);
            }
        });
    }

    handleOpenInApp(event: MouseEvent | KeyboardEvent): void {
        if ((event as MouseEvent).clientX !== 0 || (event as MouseEvent).clientY !== 0) {
            this.cardModalService.openInApp.set(this.cardModalService.currentDashboard()?.ApplicationType);
        }
    }

    private async loadJobTypeShortCode(typeId: number): Promise<void> {
        const jobTypes = await this.jobsAndBillingJobTypesService.getJobTypes();
        this.jobTypeShortCode.set(jobTypes?.find((jt) => jt.id === typeId)?.shortCode ?? null);
    }
}
